import { useState } from 'react';
import classes from './AuthForm.module.css';


const ResetPassword = () => {
  // const [message, setMessage] = useState("");
  const [passwordInput, setPasswordInput] = useState("Enter new password...")

  const submitHandler = (event) => {
    event.preventDefault();
    // Do something
  };
  const handlePasswordInput = (event) => {
    setPasswordInput(event.target.value)
  }

  return (
    <section className={"page_content"} style={{marginTop: "15vh"}}>
      <div className={classes.resetpassword}>
        <img className={classes.logo} src="/images/UNLTDTHERA_CONNECT_V2.png" alt="Unlimited therapy logo" />
        <h2 style={{fontWeight:'bold', marginTop: '2em'}}>Reset Password</h2>
        <form onSubmit={submitHandler} style={{marginTop: '2em'}}>
          <div className={classes.control}>
            <label htmlFor='password'>New Password</label>
            <input
              type='password'
              id='resetPassword'
              required
              autoComplete={"off"}
              placeholder={passwordInput}
              onChange={handlePasswordInput}
            />
          </div>
          {/*<div>{message}</div>*/}
          <div className={classes.actions}>
              <button className={"text-capitalize"}>Reset Password</button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default ResetPassword;
